import { confirmable } from 'react-confirm';
import { useTranslation } from 'react-i18next';
import StackedModal from './stacked_modal';

function ConfirmDialog({
  show,
  proceed,
  title,
  content,
  confirmText,
  cancelText,
  destructive = false,
}) {
  const { t } = useTranslation('common');
  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:button.confirm')}
      content={content || t('common:confirmation.confirm')}
      secondaryAction={
        cancelText
          ? {
              content: cancelText,
              onAction: () => {
                proceed(false);
              },
            }
          : undefined
      }
      primaryAction={{
        content: confirmText || t('common:button.confirm'),
        tone: destructive ? 'critical' : undefined,
        onAction: () => {
          proceed(true);
        },
      }}
      onClose={() => {
        proceed(false);
      }}
    />
  );
}

export default confirmable(ConfirmDialog);
